import { createApiModules } from "@repo/share-log-api-client";
import { baseHttpClient } from "@mobile/api/http-client";

export const API = createApiModules(baseHttpClient);
